import { MapboxLayerService } from '@/modules/ta/legacy/widget/services/types/MapboxLayerService';
import { ZIPCODE } from '@/modules/ta/legacy/widget/mapbox.constants';
import { MapboxDataService } from '@/modules/ta/legacy/widget/services/types/MapboxAutoZoomService';

export class MapboxZipCodeLayerService extends MapboxLayerService {
  constructor(widget) {
    super(widget, ZIPCODE);
  }

  getData(data) {
    let filteredData = MapboxDataService.getTopPercent(
      data,
      this.column.field,
      this.widget.metadata.draw_options?.auto_zoom_threshold
    );
    return filteredData.map((row) => String(row[this.groupedColumn.field]));
  }

  filterData(data) {
    return data;
  }
}
